<template>
  <div v-if="props.showMessage"
       :class="[feedback.hasError ? 'app-alert-error' : 'app-alert-warning']"
       role="alert" aria-live="off">
    <img v-if="feedback.hasError" src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <img v-else src="@ridmv/web-themes/images/icons/paper-plane-solid.svg" alt="">
    <p tabindex="-1" ref="messageRef" class="animate__animated animate__headShake" v-if="feedback.message">
      {{ feedback.message }}
    </p>
    <p tabindex="-1" ref="messageRef" class="animate__animated animate__headShake" v-else>
      {{ message }}
    </p>
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import _ from 'underscore';
import NotificationFeedback from '@/assets/_systemFeedback';

// Props
const props = defineProps({
  showMessage: {
    type: Boolean,
    required: false,
    default: false,
  },
});

// Vuex store
const store = useStore();

// Reactive state
const feedback = ref({});
const inWorkTxnMessage = ref([]);
const message = ref('');
const messageRef = ref(null); 

// Computed properties
const resNotificationSent = computed(() => store.state.resNotificationSent);
const finalizationCart = computed(() => store.state.guestLogin?.finalizationCart);
const isConsentProvided = computed(() => store.state.guestLogin?.resNotificationSent?.isConsentProvided);

// Watcher
watch(resNotificationSent, () => {
  setupMessage();
});

// Lifecycle hook
onMounted(() => {
  setupMessage();
});

// Methods
const getFeedback = () => {
  inWorkTxnMessage.value = [];
  const transactions = finalizationCart.value?.finalizeCartResponse?.transactionCart?.cartTransactions || [];
  for (let i in transactions) {
    if (transactions[i].transactionData.transactionStatus == 'In Work') {
      inWorkTxnMessage.value.push(transactions[i].transactionData.transactionId);
    }
  }

  if (inWorkTxnMessage.value.length === 0) {
    message.value = "Your transaction is completed successfully.";
  } else {
    message.value = "Following Transaction(s) have failed. Transaction ID: " + inWorkTxnMessage.value.join(",",inWorkTxnMessage.value) + ". For more information, please contact the DMV at 401-462-4368. For transaction(s) completed successfully a confirmation text and / or e-mail has been sent to the information provided."
  }

  if (resNotificationSent.value) {
    const smsError = _.find(NotificationFeedback, fbk => fbk.errorType === 'sms');
    const emailError = _.find(NotificationFeedback, fbk => fbk.errorType === 'email');
    const dblError = _.find(NotificationFeedback, fbk => fbk.errorType === 'both');
    let feedback = _.find(NotificationFeedback, fbk => fbk.errorType === 'none');
    
    if (inWorkTxnMessage.value.length !== 0) {
      feedback = { hasError: true, message: message.value };  
    } else if (!resNotificationSent.value.isSmsSentSuccessfully && !resNotificationSent.value.isEmailSentSuccessfully) {
      feedback = dblError;
    } else if (!resNotificationSent.value.isSmsSentSuccessfully) {
      feedback = smsError;
    } else if (!resNotificationSent.value.isEmailSentSuccessfully) {
      feedback = emailError;
    }

    return { hasError: feedback.errorType !== 'none', message: feedback.message };
  }
  return {};
};

const setupMessage = async () => {
  feedback.value = getFeedback();
  await nextTick();
  if (resNotificationSent.value && isConsentProvided.value && messageRef.value) {
    messageRef.value.focus();
  }
};
</script>


<style lang="scss" scoped>
@media print {
  div, img, p {
    display: none;
  }
}
</style>

